import React from 'react';

import { CircleDollarCoin } from './CircleDollarCoin';
import { PieLarge } from './PieLarge';
import { GraphLines } from './GraphLines';
import { GlobePointer } from './GlobePointer';
import { UsersGear } from './UsersGear';
import { Microchip } from './Microchip';
import { Headset } from './Headset';
import { UserClock } from './UserClock';
import { CalendarClock } from './CalendarClock';
import { Briefcase } from './Briefcase';

export const renderSvg = (icon) => {
  switch (icon) {
    case 'circle-dollar-coin':
      return <CircleDollarCoin />;
    case 'pie-large':
      return <PieLarge />;
    case 'graph-lines':
      return <GraphLines />;
    case 'globe-pointer':
      return <GlobePointer />;
    case 'users-gear':
      return <UsersGear />;
    case 'microchip':
      return <Microchip />;
    case 'headset':
      return <Headset />;
    case 'briefcase':
      return <Briefcase />;
    case 'user-clock':
      return <UserClock />;
    case 'calendar-clock':
      return <CalendarClock />;
    default:
      <CircleDollarCoin />;
  }
};
